export default __webpack_public_path__ + "static/media/Promo-Facebook-Facebook image post (1).e0435c73.jpeg";